import { withInstall } from '@sgui-plus/utils/with-install'

import Rate from './src/rate.vue'

export const SgRate = withInstall(Rate)
export default SgRate

export * from './src/rate'
